import { Box, Flex, Heading } from "@chakra-ui/react";
import ClientCard from "./ClientCard";

import abInbev from "./../../assets/images/ab-inbev.png";
import repco from "./../../assets/images/repco.png";
import technoExponent from "./../../assets/images/techno-exponent.webp";
import hybrisworld from "./../../assets/images/hybrisworld.png";
import ferisoft from "./../../assets/images/ferisoft.png";

const Clients = (): JSX.Element => {
  const clients = [
    {
      title: "AB InBev",
      image: abInbev,
    },
    {
      title: "Repco",
      image: repco,
    },
    {
      title: "Techno Exponent",
      image: technoExponent,
    },
    {
      title: "HybrisWorld",
      image: hybrisworld,
    },
    {
      title: "Ferisoft",
      image: ferisoft,
      backgroundColor: "#1a202c",
    },
  ];

  return (
    <Box width={"full"} textAlign={"center"}>
      <Heading size={"lg"}>Whom I have worked with</Heading>

      <Flex
        marginTop={6}
        justifyContent={"center"}
        wrap={"wrap"}
        alignItems={"stretch"}
        gap={6}
      >
        {clients.map((client: any, index: number) => (
          <ClientCard
            key={`client-${index}`}
            width={{ base: "100%", md: "33.33%", lg: "calc(25% - 1.5rem)" }}
            client={client}
          />
        ))}
      </Flex>
    </Box>
  );
};

export default Clients;
